var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 5.54183H9.5M6.33333 8.7085H12.6667M6.33333 11.8752H12.6667M3.95833 1.5835H15.0417C15.9161 1.5835 16.625 2.29238 16.625 3.16683V15.164C16.625 16.2606 15.5372 17.0252 14.5054 16.6538L13.269 16.2087C12.8826 16.0696 12.4574 16.086 12.0829 16.2545L10.1497 17.1244C9.73654 17.3104 9.26346 17.3104 8.85026 17.1244L6.91709 16.2545C6.54264 16.086 6.11738 16.0696 5.73104 16.2087L4.49464 16.6538C3.46284 17.0252 2.375 16.2606 2.375 15.164V3.16683C2.375 2.29238 3.08388 1.5835 3.95833 1.5835Z",
    stroke: "#4186C2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.161016b21580f3ef56a9470a9561bac7.svg";
export { ForwardRef as ReactComponent };